import { Component, Input, OnInit } from "@angular/core";
import { Cesion } from "src/app/models/Cesion/Cesion";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteRecibido } from "src/app/models/Dte/DteRecibido";
import { RespuestaEstadoDte } from "src/app/models/Dte/RespuestaEstadoDte";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Component({
	selector: "app-semaforo-estado-recibido",
	templateUrl: "./semaforo-estado-recibido.component.html",
	styleUrls: ["./semaforo-estado-recibido.component.scss"],
})
export class SemaforoEstadoRecibidoComponent implements OnInit {
	public statusAcuse: boolean = false;
	public RespuestasEstadoAcuseDte: RespuestaEstadoDte[] = [];
	@Input() row: DteRecibido;
	constructor(private localStorage: LocalStorageService) {}

	ngOnInit(): void {
		this.RespuestasEstadoAcuseDte = JSON.parse(this.localStorage.getRespuestaEstadoDte()) as RespuestaEstadoDte[];
	}

	getTooltipFirstStatus(estadoNombre: string): string {
		switch (estadoNombre) {
			case "RECIBIDO CONFORME":
				return "Recibido Conforme";
			case "RECIBIDO EN SII":
				return "Recibido en SII";
			case "RECIBIDO EN CORREO":
				return "Recibido en Correo";
			default:
				return "Estado Desconocido";
		}
	}

	getSecondDotClass(row: DteRecibido): string {
		if (row.codigoTipoDte == 52 || row.motivo.toLowerCase() == "contado") {
			return "success-dot";
		}
		if (row.respuestaEstadoId == null && row.diasPendientes != "") {
			return "warning-dot";
		} else if (row.respuestaEstadoId == null && row.diasPendientes == "") return "success-dot";
		const estado = this.RespuestasEstadoAcuseDte.find((e) => e.id === row.respuestaEstadoId);
		if (estado) {
			switch (estado.descripcion.toLowerCase()) {
				case "pago contado":
				case "no reclamado en plazo":
				case "aceptado":
				case "en el registro":
					return "success-dot";
				case "aceptado con discrepancias":
					return "warning-dot";
				case "rechazado":
					return "error-dot";
				default:
					return "void-dot";
			}
		}
		return "void-dot";
	}

	getTooltipSecondStatus(row: DteRecibido): string {
		if (row.codigoTipoDte == 52) return "No aplica acuse de recibo";
		if (row.motivo.toLowerCase() == "contado") return "Pagado al contado";
		else if (row.respuestaEstadoId == null && row.diasPendientes != "" && row.diasPendientes != "Vence Hoy") return "Acuse pendiente, " + row.diasPendientes + " restantes";
		else if (row.respuestaEstadoId == null && row.diasPendientes == "") return "En el registro";
		else if (row.respuestaEstadoId == null && row.diasPendientes == "Vence Hoy") return "Acuse pendiente, Vence hoy";
		return this.getDescripcionEstado(row.respuestaEstadoId);
	}

	getTooltipThirdStatus(row: DteRecibido): string {
		if (row.codigoTipoDte == 52) return "No aplica acuse de recibo";
		else if (row.motivo.toLowerCase() == "contado") {
			return "Pagado al contado";
		} else if (row.respuestaEstadoId == null && row.diasPendientes == "Vence Hoy") return "";
		else if((row.codigoTipoDte == 61 || row.codigoTipoDte == 56) && row.estado == 3 && row.respuestaEstadoId == null) return "Recibido Conforme";
		return this.getDescripcionEstado(row.respuestaEstadoId);
	}
	getThirdDotClass(row: DteRecibido): string {
		if (row.codigoTipoDte == 52 || row.motivo.toLowerCase() == "contado") return "success-dot";
		else if (row.respuestaEstadoId == null && row.diasPendientes == "Vence Hoy") return "void-dot";
		const estado = this.RespuestasEstadoAcuseDte.find((e) => e.id === row.respuestaEstadoId);
		if (estado) {
			switch (estado.descripcion.toLowerCase()) {
				case "aceptado":
				case "pago contado":
				case "en el registro":
				case "no reclamado en plazo":
					return "success-dot";
				case "aceptado con discrepancias":
					return "warning-dot";
				case "rechazado":
					return "error-dot";
				default:
					return "void-dot";
			}
		}
		else if((row.codigoTipoDte == 61 || row.codigoTipoDte == 56) && row.estado == 3) return "success-dot";
		return "void-dot";
	}
	getDescripcionEstado(id: string) {
		return this.RespuestasEstadoAcuseDte.find((x) => x.id == id)?.descripcion ?? "";
	}
}